<%
/* One piece of host text: plain, a phone number (tel:) or an address (Google
   Maps). Declared once, used by every list below — a local function rather
   than an EJS include, see PlanTemplate. A value that is nothing but a number
   renders as a large pill. */
function part( p ) { %><% if ( p.tel ) { %><a class="tel<%= p.pill ? ' tel--pill' : '' %>" href="tel:<%= p.tel %>"><% if ( p.pill ) { %><i class="icon icon--phone" aria-hidden="true"></i><% } %><%= p.text %></a><% } else if ( p.map ) { %><a class="maplink" href="<%= p.map %>" target="_blank" rel="noopener" aria-label="<%= _lcs( '{address} in Google Maps öffnen', { address : p.text } ) %>"><i class="icon icon--map-pin" aria-hidden="true"></i><%= p.text %></a><% } else { %><%= p.text %><% } %><% }
%><div class="screen screen--subpage">

  <header class="subpage__hero ga-photo ga-photo--valley">
    <div class="subpage__hero-scrim"></div>
    <button class="detail__round" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>"><i class="icon icon--arrow-left"></i></button>
    <div class="subpage__hero-title">
      <p class="belturo-eyebrow subpage__eyebrow"><%= house %></p>
      <h1 class="subpage__heading"><%= _lcs( 'Gästemappe' ) %></h1>
    </div>
  </header>

  <div class="subpage__body">

    <!-- Emergency numbers first, outside every accordion: in an emergency the
         guest must not have to search, expand or type. -->
    <div class="sos" role="group" aria-label="<%= _lcs( 'Notruf' ) %>">
      <% emergency.forEach( function( n ) { %>
        <a class="sos__btn" href="tel:<%= n.tel %>">
          <i class="icon icon--phone-call sos__icon" aria-hidden="true"></i>
          <span class="sos__num"><%= n.tel %></span>
          <span class="sos__label"><%= n.label %></span>
        </a>
      <% } ); %>
    </div>

    <% if ( !hasContent ) { %>
    <p class="subpage__text subpage__text--empty">
      <%= _lcs( 'Dein Gastgeber hat hier noch keine Informationen hinterlegt. Schau später noch einmal vorbei — oder frag einfach direkt nach.' ) %>
    </p>
    <% } %>

    <% if ( sections.length > 1 ) { %>
    <div class="subpage__tools">
      <button type="button" class="subpage__toolbtn" data-id="toggle-all"><%= _lcs( 'Alle ausklappen' ) %></button>
    </div>
    <% } %>

    <% sections.forEach( function( sec ) { %>
    <!-- Native <details>: the disclosure semantics, the keyboard handling and
         the browser's find-in-page auto-expansion all come with it. -->
    <details class="acc"<%= sec.isOpen ? ' open' : '' %>>
      <summary class="acc__head">
        <i class="icon icon--<%= sec.icon %> acc__icon" aria-hidden="true"></i>
        <h3 class="subpage__subhead acc__title"><%= sec.title %></h3>
        <i class="icon icon--chevron-down acc__chev" aria-hidden="true"></i>
      </summary>

      <div class="acc__body">
        <% if ( sec.rows.length > 0 ) { %>
        <div class="infolist">
          <% sec.rows.forEach( function( r ) { %>
            <div class="infolist__row<%= r.sub ? ' infolist__row--sub' : '' %>"<% if ( r.blockId ) { %> data-block="<%= r.blockId %>"<% } %>>
              <% if ( !r.sub ) { %><i class="icon icon--<%= r.icon %> infolist__icon"></i><% } %>
              <span class="infolist__label"><%= r.label %></span>
              <span class="infolist__meta"><% r.metaParts.forEach( part ); %></span>
            </div>
          <% } ); %>
        </div>
        <% } %>

        <% sec.texts.forEach( function( t ) { %>
          <h4 class="subpage__blockhead"<% if ( t.blockId ) { %> data-block="<%= t.blockId %>"<% } %>><i class="icon icon--<%= t.icon %>"></i> <%= t.title %><% if ( t.meta ) { %><span class="subpage__blockmeta"><% t.metaParts.forEach( part ); %></span><% } %></h4>
          <% if ( t.bodyParts.length > 0 ) { %><p class="subpage__text"><% t.bodyParts.forEach( part ); %></p><% } %>
          <% if ( t.items.length > 0 ) { %>
          <div class="infolist infolist--block">
            <% t.items.forEach( function( it ) { %>
              <div class="infolist__row infolist__row--sub">
                <span class="infolist__label"><%= it.label %></span>
                <span class="infolist__meta"><% it.valueParts.forEach( part ); %></span>
              </div>
            <% } ); %>
          </div>
          <% } %>
          <% if ( t.attachments && t.attachments.length > 0 ) { %>
          <div class="downloads">
            <% t.attachments.forEach( function( a ) { %>
              <a class="downloads__item" href="<%= a.url %>" target="_blank" rel="noopener noreferrer" download>
                <i class="icon icon--<%= a.icon %> downloads__icon"></i>
                <span class="downloads__name"><%= a.name %></span>
                <i class="icon icon--download downloads__action"></i>
              </a>
            <% } ); %>
          </div>
          <% } %>
        <% } ); %>
      </div>
    </details>
    <% } ); %>

  </div>

</div>
